<template>
  <svg width="15px" height="15px" viewBox="10 11 12 10" version="1.1" xmlns="http://www.w3.org/2000/svg"
       xmlns:xlink="http://www.w3.org/1999/xlink">
    <title>5BC8EBEE-A350-46BF-A2B5-6E9EDD961868</title>
    <defs>
      <polygon id="path-2" points="0 10.59 4.94466937 6 0 1.41 1.52226721 0 8 6 1.52226721 12" :fill="fill"></polygon>
    </defs>
    <g id="Apps" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
      <g id="Dashboard---Admin-" transform="translate(-666.000000, -381.000000)">
        <g id="Variables/Icon/Arrow-Right-Copy" transform="translate(367.000000, 295.000000)">
          <g transform="translate(299.000000, 86.000000)">
            <g id="Icon" transform="translate(12.000000, 10.000000)">
              <mask id="mask-3" fill="white">
                <use xlink:href="#path-2"></use>
              </mask>
              <use id="Mask" fill="#000000" fill-rule="nonzero" xlink:href="#path-2"></use>
            </g>
          </g>
        </g>
      </g>
    </g>
  </svg>
</template>

<script>
export default {
  props: {
    fill: {
      required: false,
      default: '#0db4e6',
    },
  },

  name: 'ForwardChevronIcon',
};
</script>
